import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Controller, useForm } from 'react-hook-form'
import { Box, TextField, Typography } from '@material-ui/core'

import { BaseDialog } from 'components'

import theme from 'theme'

import schema from './schema'

const AssumeRiskDialog = ({
  open,
  setOpen,
  activityCode,
  loading,
  onAssumeRisk,
}) => {
  const { control, errors, handleSubmit, reset } = useForm({
    validationSchema: schema,
    defaultValues: { justification: '' },
  })

  const handleAssumeRisk = ({ justification }) => onAssumeRisk(justification)

  // O menu não remonta no refresh: a modal reabre sempre vazia.
  useEffect(() => {
    if (open) reset({ justification: '' })
  }, [open])

  return (
    <BaseDialog
      open={open}
      setOpen={setOpen}
      title="Assumir o risco"
      closeButtonText="Cancelar"
      actionButtonText="Assumir risco"
      formRef="assume-risk-dialog-form"
      loading={loading}
      fullWidth
    >
      <Box
        component="form"
        id="assume-risk-dialog-form"
        onSubmit={handleSubmit(handleAssumeRisk)}
        display="flex"
        flexDirection="column"
        gridGap={theme.spacing(2)}
      >
        <Typography>
          {`O controle ${activityCode} foi reprovado. Ao assumir o risco, a organização registra que optou por não resolver a pendência apontada no parecer, e o controle não passará por nova revisão. Se mudar de ideia, é possível desfazer pelo menu do controle, e ele volta a ficar reprovado.`}
        </Typography>
        <Controller
          control={control}
          name="justification"
          as={
            <TextField
              label="Justificativa"
              variant="outlined"
              error={!!errors?.justification}
              helperText={errors?.justification?.message}
              multiline
              fullWidth
              minRows={4}
              maxRows={12}
            />
          }
        />
      </Box>
    </BaseDialog>
  )
}

AssumeRiskDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  activityCode: PropTypes.string,
  loading: PropTypes.bool,
  onAssumeRisk: PropTypes.func.isRequired,
}

export default AssumeRiskDialog
